var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProcessCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "CircularProgressbar ",
    viewBox: "0 0 100 100",
    "data-test-id": "CircularProgressbar",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "CircularProgressbar-trail",
    d: "           M 50,50           m 0,-46           a 46,46 0 1 1 0,92           a 46,46 0 1 1 0,-92         ",
    strokeWidth: 8,
    fillOpacity: 0,
    style: {
      strokeDasharray: "289.027px, 289.027px",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "CircularProgressbar-path",
    d: "           M 50,50           m 0,-46           a 46,46 0 1 1 0,92           a 46,46 0 1 1 0,-92         ",
    strokeWidth: 8,
    fillOpacity: 0,
    style: {
      strokeDasharray: "289.027px, 289.027px",
      strokeDashoffset: 285
    }
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "CircularProgressbar-text",
    x: 50,
    y: 50
  }, "\n\t\t\t\t\t\t66%\n\t\t\t\t\t")));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProcessCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/process-circle.fb4416fa.svg";
export { ForwardRef as ReactComponent };